import React from "react";
import Stack from "../mui/Stack";
import FormControlLabel from "../mui/FormControlLabel";
import Checkbox from "../mui/Checkbox";
import Typography from "../mui/Typography";
import FormGroup from "../mui/FormGroup";
import { Controller } from "react-hook-form";

interface Props {
  controller: any;
}

const filterField = [
  { label: "All", value: "all" },
  { label: "Quarterly", value: "quarterly" },
  { label: "Yearly", value: "yearly" },
];

const FilterTarget: React.FC<Props> = (props) => {
  const { controller } = props;

  return (
    <div>
      <Controller
        name="filter.targetDuration"
        control={controller}
        render={({ field }) => (
          <>
            <Typography>Target duration</Typography>
            <FormGroup>
              <Stack direction="row">
                {filterField.map((btn) => (
                  <FormControlLabel
                    {...field}
                    key={btn.value}
                    control={
                      <Checkbox
                        checked={(() => {
                          if (btn.value === "all") {
                            return (
                              field.value.includes("quarterly") &&
                              field.value.includes("yearly") &&
                              field.value.length === 2
                            );
                          }
                          return field.value.includes(btn.value);
                        })()}
                        sx={{
                          fontSize: "10px",
                          "& .MuiSvgIcon-root": {
                            color: "#828282 !important",
                          },
                          "&.Mui-checked .MuiSvgIcon-root": {
                            color: "#FFCA09 !important",
                          },
                        }}
                        onChange={(e) => {
                          const isChecked = e.target.checked;

                          if (btn.value === "all") {
                            if (isChecked) {
                              field.onChange(["quarterly", "yearly"]);
                            } else {
                              field.onChange([]);
                            }
                          } else {
                            const updatedValues = isChecked
                              ? [...field.value, btn.value]
                              : field.value.filter(
                                  (value: string) => value !== btn.value
                                );

                            if (
                              updatedValues.includes("quarterly") &&
                              updatedValues.includes("yearly")
                            ) {
                              // Ensure "all" is treated as selected logically but not included in the value
                              if (!updatedValues.includes("all")) {
                                field.onChange(["quarterly", "yearly"]);
                              }
                            } else {
                              field.onChange(updatedValues);
                            }
                          }
                        }}
                      />
                    }
                    label={btn.label}
                    value={btn.value}
                  />
                ))}
              </Stack>
            </FormGroup>
          </>
        )}
      />
    </div>
  );
};

export default FilterTarget;
